import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function FutureFacingInvestment() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="19217" id="the-shield-of-expertise" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-secondary dark">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-r from-secondary/90 via-secondary/60 to-transparent z-10" />
        <div className="absolute inset-0 bg-secondary/20 z-10 mix-blend-multiply" />
        <div className="w-full h-full bg-cover bg-center bg-no-repeat bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587918/img/nubaria_complex_drone_shot.png)] grayscale-[0.3] brightness-[0.7] contrast-[1.1]" role="img" aria-label="Modern industrial facility at blue hour" />
      </div>

      {}
      <div ref={ref} className={`relative z-20 container mx-auto px-4 md:px-6 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="max-w-5xl mx-auto space-y-8">
          {}
          <h1 className="text-5xl md:text-7xl lg:text-[72px] font-extrabold font-sans text-white leading-[1.05] tracking-tighter drop-shadow-2xl">
            Expert Safety Solutions & <br className="hidden md:block" />
            <span className="text-primary">Strategic Risk</span> Mitigation
          </h1>

          {}
          <p className="text-lg md:text-2xl font-sans text-white/90 max-w-3xl mx-auto leading-relaxed font-normal">
            Providing tailored safety audits and compliance programs to help organizations identify hazards 
            and protect their most critical industrial and corporate assets.
          </p>

          {}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-bold text-lg px-10 h-16 rounded-sm shadow-xl transition-all hover:scale-[1.02] border-none">
              <Link to="/LetsTalkSafetyPage">
                Get a Safety Audit
                <ArrowRight className="ml-2 h-6 w-6" />
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="border-white/40 text-white hover:bg-white hover:text-secondary bg-transparent font-semibold text-lg px-10 h-16 rounded-sm backdrop-blur-md transition-all hover:scale-[1.02]">
              <Link to="/TheExpertPage">
                Watch Process
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 animate-bounce hidden md:block">
        <div className="w-6 h-10 border-2 border-white/20 rounded-full flex justify-center p-1">
          <div className="w-1 h-2 bg-primary rounded-full" />
        </div>
      </div>
    </section>;
}